<template>
	<div v-loading="loading" style="position: relative;flex: 1;height: 100%;overflow: hidden;">
		<div style="width: 100%;height: 100%;padding: 15px;overflow-x: hidden;overflow-y: auto;">
			<!-- 顶部查询 -->
			<div style="border: 1px solid #ccc;background: #f7f7f7;border-radius: 5px;">
				<div class="base_inquire" style="padding: 20px 30px 5px;border-bottom: 1px solid #ccc;">
					<div class="b_item">
						<span class="b_label">带训人：</span>
						<el-input v-model="search_code" class="b_inp" placeholder="带训人"></el-input>
					</div>
					<el-button type="primary" style="margin-right: 15px;" @click="handleSearchTrainer">查询</el-button>
					<div v-if="search_trainer.id" class="b_item">
						<span class="b_label">当前带训人：{{ search_trainer.eglTrainerName }}</span>
					</div>
				</div>
				<div class="base_inquire" style="padding: 20px 30px 5px;">
					<div class="b_item">
						<span class="b_label">开始日期：</span>
						<el-date-picker
							v-model="search_startDate"
							:editable="false"
							placeholder="开始日期"
							type="date"
							value-format="yyyy-MM-dd"
							@change="handleSearchStartDateChange"
						>
						</el-date-picker>
					</div>
					
					<div class="b_item">
						<span class="b_label">结束日期：</span>
						<el-date-picker
							v-model="search_endDate"
							:editable="false"
							placeholder="结束日期"
							type="date"
							value-format="yyyy-MM-dd"
							@change="handleSearchEndDateChange"
						>
						</el-date-picker>
					</div>
					
					<div class="b_item">
						<span class="b_label">带训类型：</span>
						<el-select v-model="search_type" class="b_inp">
							<el-option :value="1" label="第一带训人"></el-option>
							<el-option :value="2" label="第二带训人"></el-option>
						</el-select>
					</div>

					<el-button type="primary" @click="handleSearchUsers">查询</el-button>
				</div>
			</div>
			<!-- 顶部查询 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="firmName"
						label="所属机构"
					>
					</el-table-column>
					<el-table-column
						prop="guideDoctorName"
						label="第一带训人"
					>
					</el-table-column>
					<el-table-column
						prop="guideSecondDoctorName"
						label="第二带训人"
					>
					</el-table-column>
					<el-table-column
						prop="createDate"
						label="创建日期"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	import BaseMethods from '../../../../assets/js/base.js';
	
	export default {
		data() {
			return {
				loading: false,
				
				search_code: '',
				search_trainer: {},
				search_startDate: BaseMethods.getTime(new Date().getTime()),
				search_endDate: '',
				search_type: 1,
				
				currentPage: 1,
				total: 0,
				tableData: []
			}
		},
		methods: {
			/******************** @Events *************************/
			// 切换查询时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 切换查询时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 查询带训人
			handleSearchTrainer() {
				if (!this.search_code.trim()) {
					this.$message.error('请输入带训人！！！');
					return false;
				}
				this.searchTrainer();
			},
			// 查询用户
			handleSearchUsers() {
				if (!this.search_trainer.id) {
					this.$message.error('请先查询带训人！！！');
					return false;
				}
				this.currentPage = 1;
				this.searchUsers();
			},
			// 切换页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.searchUsers();
				}
			},
			
			/******************** @Function *************************/
			// 查询带训人
			searchTrainer() {
				const that = this;
				that.loading = true;
				var requestData = { 
					code: that.search_code
				};
				Api.getTrainerByCode(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.search_trainer = res.data.data;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 查询用户
			searchUsers() {
				const that = this;
				that.loading = true;
				var requestData = { 
					"endTime": that.search_endDate,
					"guideDoctorId": that.search_trainer.id,
					"limit": 10,
					"pageNum": that.currentPage,
					"startTime": that.search_startDate,
					"type": that.search_type
				};
				Api.findUsersByTrainer(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let data = [];
						that.total = res.data.data.totalItems;
						res.data.data.data.forEach((v) => {
							data.push({
								name: v.userName,
								firmName: v.uenterpriseName,
								guideDoctorName: v.guideDoctorName,
								guideSecondDoctorName: v.guideSecondDoctorName,
								createDate: v.createTime ? v.createTime.split(' ')[0] : ''
							});
						});
						that.tableData = data;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startDate = new Date(this.search_startDate).getTime(),
						endDate = new Date(this.search_endDate).getTime();
					if (endDate < startDate) {
						this.search_endDate = '';
						this.$message({
							message: '结束时间不能小于开始时间',
							type: 'warning'
						});
					}
				}
			},
		}
	}
</script>

<style scoped>
</style>
